import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('https://public.readdy.ai/ai/img_res/c6eecc2f77de296e62e33aad6f76fa47.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-2xl">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight uppercase">
            Build Skills.<br />
            Launch Careers.
          </h1>
          <p className="text-xl text-white mb-8 leading-relaxed">
            Get hands-on training in high-demand trades and step into a career that pays. Fast programs. Real skills. Job-ready results.
          </p>
          <Button 
            href="#programs" 
            variant="primary" 
            icon={<i className="fas fa-arrow-right"></i>}
          >
            Explore Now
          </Button>
        </div>
      </div>
    </section>
  );
}
